import React, { useState } from "react";
import { T_PAQUETE, checkoutPaqueteCfdi } from "../../lib/cfdi";

export default function PaqueteCfdi({ cupo, puede }) {
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState(false);
  if (!puede?.("configuracion") || !cupo?.paquete_disponible || !cupo.paquete_precio_texto) return null;
  const comprar = async () => {
    if (!window.confirm(T_PAQUETE.confirmar(cupo.paquete_cantidad, cupo.paquete_precio_texto))) return;
    setOcupado(true);
    setError(false);
    try { await checkoutPaqueteCfdi(); } catch { setError(true); } finally { setOcupado(false); }
  };
  return (
    <span className="ml-2 inline-block">
      <button type="button" onClick={comprar} disabled={ocupado} data-testid="cfdi-paquete-comprar"
              className="rounded-lg border px-3 py-1.5 text-xs disabled:opacity-50">
        {ocupado ? T_PAQUETE.abriendo : T_PAQUETE.comprar(cupo.paquete_cantidad)}
      </button>
      {error && <span role="alert" className="ml-2" data-testid="cfdi-paquete-error">{T_PAQUETE.error}</span>}
    </span>
  );
}
